/* eslint-disable no-useless-escape */

import * as yup from 'yup';

export const validationSchema = yup.object({
    propsModule: yup
        .string()
        .required('Required'),
    propsRef: yup
        .string()
        .required('Required'),
    propsKey: yup
        .string()
        .required('Required'),
    propsField: yup
        .string()
        .required('Required'),
    propsFieldValue: yup
        .string()
        .required('Required'),
    propsValue: yup
        .string()
        .required('Required'),
    isMultiple: yup
        .string()
        .required('Required')
})

export const initialValues = {
    propsModule: "",
    propsRef: "",
    propsKey: "",
    propsField: "",
    propsFieldValue: "0",
    propsValue: "",
    isMultiple: "0"
}
